import { render, staticRenderFns } from "./supplierCertification.vue?vue&type=template&id=30407ad6&scoped=true"
import script from "./supplierCertification.vue?vue&type=script&lang=js"
export * from "./supplierCertification.vue?vue&type=script&lang=js"
import style0 from "./supplierCertification.vue?vue&type=style&index=0&id=30407ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30407ad6",
  null
  
)

export default component.exports